import React from "react";
import { useAuth } from "../lib/auth";

/**
 * Wraps a region (e.g. the Calculator form) and intercepts any attempt by a
 * guest to focus or interact with form fields. Reading and tab navigation stay
 * fully usable; attempting to type/click a field opens the admin login modal.
 *
 * Action buttons (Save / Download / Add ingredient / etc.) should already be
 * wrapped with `auth.guard(fn)` — they are NOT intercepted here so their own
 * onClick logic fires.
 */
const FIELD_SELECTOR = 'input, textarea, select, [contenteditable="true"]';

export default function GuestFieldLock({ children }) {
  const { isAdmin, openLogin } = useAuth();

  const onMouseDownCapture = (e) => {
    if (isAdmin) return;
    const t = e.target;
    if (t && t.matches && t.matches(FIELD_SELECTOR)) {
      e.preventDefault();
      e.stopPropagation();
      try { t.blur(); } catch {}
      openLogin();
    }
  };

  const onFocusCapture = (e) => {
    if (isAdmin) return;
    const t = e.target;
    if (t && t.matches && t.matches(FIELD_SELECTOR)) {
      e.stopPropagation();
      try { t.blur(); } catch {}
      openLogin();
    }
  };

  const onKeyDownCapture = (e) => {
    if (isAdmin) return;
    const t = e.target;
    if (t && t.matches && t.matches(FIELD_SELECTOR)) {
      e.preventDefault();
      e.stopPropagation();
      openLogin();
    }
  };

  return (
    <div
      onMouseDownCapture={onMouseDownCapture}
      onFocusCapture={onFocusCapture}
      onKeyDownCapture={onKeyDownCapture}
      data-guest-locked={!isAdmin ? "true" : "false"}
    >
      {children}
    </div>
  );
}
